import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ICONS } from '../../icons';

/**
 * InlineEditSection - Reusable inline edit for profile attributes
 * Edits in-place within the grid cell instead of using a popup overlay
 */
export default function InlineEditSection({
  icon,
  title,
  isEmpty,
  isEditing,
  onStartEdit,
  onSave,
  onCancel,
  displayContent,
  editContent,
  saveDisabled = false,
  compact = false
}) {
  return (
    <div className={`preference-group-display ${isEditing ? 'editing' : ''} ${compact ? 'compact' : ''}`}>
      <div className="preference-group-header">
        <FontAwesomeIcon icon={icon} className="preference-icon" />
        <span className="preference-title">{title}</span>
        {!isEditing && (
          <button
            className={`inline-edit-btn ${isEmpty ? 'add' : 'edit'}`}
            onClick={onStartEdit}
            title={isEmpty ? `Add ${title}` : `Edit ${title}`}
          >
            <FontAwesomeIcon icon={isEmpty ? ICONS.PLUS : ICONS.EDIT} />
          </button>
        )}
      </div>
      {isEditing ? (
        <div className="inline-edit-content">
          {editContent}
          <div className="inline-edit-actions">
            <button onClick={onCancel} className="inline-cancel-btn">
              Cancel
            </button>
            <button onClick={onSave} className="inline-save-btn" disabled={saveDisabled}>
              <FontAwesomeIcon icon={ICONS.CHECK} />
              <span>Save</span>
            </button>
          </div>
        </div>
      ) : (
        <div className="preference-badges">
          {displayContent}
        </div>
      )}
    </div>
  );
}
